module.exports = __webpack_public_path__ + "static/img/co-operate-03.5d1c4b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-03.png
// module id = VyrQ
// module chunks = 1